import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56581658"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card p-4" }
const _hoisted_2 = { class: "p-1 m-0 h-auto" }
const _hoisted_3 = { class: "d-flex justify-content-between w-100 border-bottom py-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-blue" }, "Mis invitados", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Ver todo")
const _hoisted_6 = { class: "card-body p-2 overflow-auto" }
const _hoisted_7 = { class: "d-flex align-items-center col-8" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-50px p-0 bg-light rounded-circle me-2" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "media/avatars/blank.png",
      alt: "",
      class: "h-50 rounded-circle",
      style: {"width":"50px"}
    })
  ])
], -1))
const _hoisted_9 = {
  href: "#",
  class: "fs-6 text-gray text-hover-blue"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center col-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-block text-end text-gray" }, [
    /*#__PURE__*/_createElementVNode("p", {
      style: {"font-size":"10px"},
      class: "text-gray fw-bold"
    }, "grupo"),
    /*#__PURE__*/_createElementVNode("p", null, "bucaramanga")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          to: "listar-invitados",
          class: "text-blue"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usuarios, (user, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "d-flex mb-2",
          key: i
        }, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", null, [
              _createElementVNode("a", _hoisted_9, _toDisplayString(user.nombre), 1)
            ])
          ]),
          _hoisted_10
        ]))
      }), 128))
    ])
  ]))
}